module.exports = __webpack_public_path__ + "fonts/nunito-black.78bc115.woff";